import ParcelexApi from '../../services/parcelex';

export default {
  getOnboarding({ transactionId, returnTransaction = true, isMobile }) {
    const query = new URLSearchParams({
      transactionId,
      returnTransaction,
      returnTransactionAndCheckout: returnTransaction,
      isMobile,
    }).toString();

    return ParcelexApi.get(`onboarding/v2/?${query}`);
  },
  sendImage({ onboardingId, step, imageB64, extraData }) {
    return ParcelexApi
      .post(`onboarding/v2/${onboardingId}/${step.toLowerCase()}/send`, {
        base64Img: imageB64,
        ...extraData,
      });
  },
  resendConfirmation({ onboardingId, isMobile, type }) {
    return ParcelexApi.post(`onboarding/v2/${onboardingId}/confirmation/resend`, {
      isMobile,
      type,
    });
  },
  sendConfirmation({ onboardingId, securityCode }) {
    return ParcelexApi.post(`onboarding/v2/${onboardingId}/confirmation/send`, {
      securityCode,
    });
  },
  sendContractConfirmation({ onboardingId }) {
    return ParcelexApi.post(`onboarding/v2/${onboardingId}/contract`, {
      onboardingId,
    });
  },
  getInsuranceOptions(onbordingId) {
    return ParcelexApi.get(`insurance/${onbordingId}`);
  },
  sendInsuranceConfirmation(onbordingId, hasInsurance) {
    return ParcelexApi.post(`onboarding/v2/${onbordingId}/insurance`, { hasInsurance });
  },
  downloadPDFFromS3(filename) {
    return ParcelexApi
      .get(`onboarding/v2/s3/pdf/${filename}`,
        { responseType: 'blob' });
  },
  createIuguUser({ userId, transactionId, token }) {
    return ParcelexApi.post(`/user/${userId}/transaction/${transactionId}`, { downPayment: true, token });
  },
  payWithCreditCard({ userId, transactionId, isPaymentMethodSaved, token }) {
    if (!isPaymentMethodSaved) {
      return ParcelexApi.post(`transactions/${transactionId}/payment/creditCard/${userId}`, { downPayment: true, isPaymentMethodSaved, token });
    }
    return ParcelexApi.post(`transactions/${transactionId}/payment/creditCard/${userId}`, { downPayment: true, isPaymentMethodSaved });
  },
};
